<template>
    <div class="md-layout">
        <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">

            <md-card>
                <md-card-header class="md-card-header-icon md-card-header-yellow">
                    <div class="card-icon">
                        <md-icon>sentiment_satisfied_alt</md-icon>
                    </div>
                </md-card-header>
                <md-card-content>
                    <h3>{{$t('pages.dashboard.welcome')}} {{user.fullname}}</h3>
                </md-card-content>
            </md-card>
        </div>
        <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50">

         <!---->
           <my-orders-card></my-orders-card>
            <!---->
            
        </div>
        <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
            
        </div>
        <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25">
         
        </div>
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33">
           
        </div>
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33">
           
        </div>
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33">
            
        </div>
        <div class="md-layout-item md-size-100">
           
        </div>
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33">
           
        </div>
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33">
            
        </div>
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33">
            
        </div>
    </div>
</template>

<script>
    import {} from "@/components";
    import MyOrdersCard from "./Components/MyOrdersCard.vue";
    import {mapGetters} from 'vuex';

    export default {
        components: {
            MyOrdersCard:MyOrdersCard
        },
        created() {
          if(!this.user.roles || this.user.roles.length === 0)
          {
            this.$router.push({ path: "/orders/myorders"});
          }
        },
        methods: {
            init() {
              
            },
            refresh() {
                this.init();
            }
        },
        computed : {
          ...mapGetters(["user"])  
        },
        data() {
            return {
              
            };
        }
    };
</script>
